import { Type } from "class-transformer";
import { CalendarEvent } from "./CalendarEvent";
import { Project } from "./Project";
import { ProjectStatistics } from "./ProjectStatistics";
import { ProjectPlanningService } from "../services/project-planning.service";

export class ProjectDto {
    //netgen start
    @Type(() => Project)
    project: Project;
    @Type(() => ProjectStatistics)
    stats: ProjectStatistics;
    @Type(() => CalendarEvent)
    events: CalendarEvent[];
    //netgen end

    getAllEditorsText(service: ProjectPlanningService, boldRoles = false): string {
        return service.getAllEditorsText(this.events, boldRoles, false);
    }

    isEditor(userId: number): boolean {
        return this.events?.some(e => e.isEditor(userId)) ?? false;
    }
}
